import { API_ENDPOINTS } from "../constants/apiEndpoints";
import axiosInstance from "../config/axiosInstance";
import { normalizeUploadedImageUrl } from "./uploadImage";

export const getSectionContentCardsByLanguage = async (
  languageCode,
  navMenuId,
) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.SECTION_CONTENT_CARDS.GET_BY_LANGUAGE(languageCode),
    { params: navMenuId ? { navMenuId } : undefined },
  );
  const data = response.data;
  let result = [];
  if (data && data.success && Array.isArray(data.data)) {
    result = data.data;
  } else if (Array.isArray(data)) {
    result = data;
  } else if (data && Array.isArray(data.data)) {
    result = data.data;
  }

  return result.map((card) => ({
    ...card,
    imgURL: normalizeUploadedImageUrl(
      card.imgURL || card.imgUrl || card.imageUrl || "",
    ),
  }));
};
